import React from 'react';
import { createRoot } from 'react-dom/client';

console.log(
  '%c✦ Glow Lab',
  'font-family: serif; font-size: 14px; color: #D4649A;'
);

const rootElement = document.getElementById('root');

function renderFallback(message: string) {
  if (!rootElement) return;
  rootElement.innerHTML = `
    <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;font-family:system-ui,sans-serif;padding:24px;background:#fff;color:#2b1f3a;text-align:center;">
      <div style="max-width:480px;">
        <h1 style="font-family:'Cormorant Garamond',Georgia,serif;font-size:28px;margin-bottom:12px;">Chargement impossible</h1>
        <p style="color:#6b6480;margin-bottom:20px;">${message}</p>
        <button onclick="location.reload()" style="padding:10px 20px;border:none;border-radius:9999px;background:#D4649A;color:#fff;font-weight:600;cursor:pointer;">Rafraîchir</button>
      </div>
    </div>
  `;
}

if (!rootElement) {
  document.body.innerHTML = `
    <div style="padding: 20px; color: red; background: #ffe6e6;">
      <h1>Element 'root' non trouvé</h1>
    </div>
  `;
} else {
  const root = createRoot(rootElement);

  import('./App')
    .then(({ default: App }) => {
      root.render(<App />);
    })
    .catch((err) => {
      console.error('Failed to load App:', err);
      renderFallback(
        "Une erreur est survenue pendant le chargement de l'application. Veuillez rafraîchir la page."
      );
    });

  window.addEventListener('error', (e) => {
    if (e?.message && /createContext/.test(String(e.message))) {
      console.error('Fatal bootstrap error:', e.message);
      renderFallback(
        "Une erreur est survenue pendant le chargement de l'application. Veuillez rafraîchir la page."
      );
    }
  });
}
